import React, { useState } from 'react'
import FuelSludgeBilgeStep from './steps/FuelSludgeBilgeStep'
import SealsStep from './steps/SealsStep'
import SoundingDraftTempStep from './steps/SoundingDraftTempStep'
import { useTranslation } from 'react-i18next'
import VerticalStepper from 'components/VerticalStepper'
import VesselInfoStep from './steps/VesselInfoStep'

import './robGeneralTab.less'

const getRobSurveySteps = t => [
  {
    key: 'vesselInfoAndSurveyLog',
    label: t('rob.survey.steps.vesselInfoAndSurveyLog'),
  },
  {
    key: 'seals',
    label: t('rob.survey.steps.seals'),
  },
  {
    key: 'soundingDraftAndTemperature',
    label: t('rob.survey.steps.soundingDraftAndTemperature'),
  },
  {
    key: 'fuelSludgeBilgeAndComments',
    label: t('rob.survey.steps.fuelSludgeBilgeAndComments'),
  },
]

const RobGeneralTab = () => {
  const { t } = useTranslation()
  const steps = getRobSurveySteps(t)
  const [activeStep, setActiveStep] = useState(0)
  const stepScreens = [
    <VesselInfoStep
      key="vesselInfoAndSurveyLog"
      onNext={() => setActiveStep(1)}
    />,
    <SealsStep key="seals" />,
    <SoundingDraftTempStep key="soundingDraftAndTemperature" />,
    <FuelSludgeBilgeStep key="fuelSludgeBilgeAndComments" />,
  ]

  return (
    <div className="rob-general-tab__body">
      <div className="rob-general-tab__stepper-panel">
        <VerticalStepper
          activeStep={activeStep}
          onStepClick={setActiveStep}
          steps={steps}
        />
      </div>
      <div className="rob-general-tab__content-panel">
        {stepScreens[activeStep]}
      </div>
    </div>
  )
}

export default RobGeneralTab
